// extracted by mini-css-extract-plugin
export default {"imageContainer":"Gda-z","summaryPar":"Hda-z","ratingCategories":"Ida-z","reviewerInfo":"Jda-z","reviewTypes":"Kda-z","expanded":"Lda-z"};